<zs-card class="zs-card" class="left-arrow">
  <header>
    <div>
      <span>{{nodedata.name}}</span>
      <span class="zs-icon zs-card-icon {{ nodedata.status == 'Completed' ? 'zs-icon-check-success': nodedata.status == 'Running' ? '' : 'zs-icon-error'}}"></span>
    </div>
  </header>
  <section>
    <app-zs-progress-bar
      [value]="1" [status]="nodedata.status" [label]="false" [animate]="false">
    </app-zs-progress-bar>
    <div class="message">
      @if (nodedata.status == 'Completed') {
        <div class="success-message">
          <span>Succeeded without errors</span>
        </div>
      }
      @if (nodedata.status == 'Running') {
        <div class="running-message">
          <span>Running - {{nodedata.completion}}% completed</span>
        </div>
      }
      @if (nodedata.status == 'Failed') {
        <div class="error-message">
          <span>Failed</span>
        </div>
      }
    </div>
    @if (nodedata.status == 'Failed') {
      <div class="view-error-link" >
        <a>View Errors</a>
      </div>
    }
  </section>
  <footer>
    @if (nodedata.status == 'Completed') {
      <span>Completed</span>
    }
    @if (nodedata.status != 'Completed') {
      <span>Avg. time to complete</span>
    }
    <span class="execution-time">{{nodedata.time}}</span> </footer>
  </zs-card>
  <!-- dataTransfer : { name: 'CONFIG DATA LOAD', status: 'Success', completion: '100', time: '1 hr ago', childs: []},
  // dataLanding: ['DQM'], -->